<template>
    <div>
        <div>
            <img src="../../assets/MK体育 - MK(中国)一站式服务官方网站/product/6.png" style="width: 100%;height: auto" alt="">
        </div>
        <div class="index-div-content product-info-div">
            <el-row  type="flex" class="product-info-div-flex">
                <el-col :xs="24" :sm="14">
                    <router-link to='/product/belt/info'><h3 class="font-24 product-header">输送带撕裂检测装置</h3></router-link>
                    <router-link to='/product/belt/info'><h3 class="font-18 product-header">「标准版」</h3></router-link>
                    <p class="product-content">mk体育智能皮带撕裂检测系统以皮带撕裂检测主体为核心，整合结构光扫描胶带表面，高帧率CCD相机连续拍摄成像技术、机器视觉提取结构光成像轮廓线技术、连续帧实时识别胶带撕裂或胶带表面技术，实现对输送机皮带实时智能检测预警。</p>
                    <router-link to='/product/belt/info'>
                    <el-button type="primary" class="button " style="width: 70px">
                        详情
                    </el-button></router-link>
                </el-col>
                <el-col :xs="24" :sm="10">
                    <div class="product-image-zoom">
                        <div class='magnify'>
                            <div class='large'></div>
                            <img src="../../assets/MK体育 - MK(中国)一站式服务官方网站/product/7.png" class='small'  alt="">
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>


    </div>
</template>

<script>
    export default {
        name: "belt",


    }
</script>
<style scoped lang="scss">


</style>